module.exports = __webpack_public_path__ + "static/media/smart_plan.47737e58.svg";